import { filterResponse, serverFetch } from '../api'
import type { Topic } from '../types/topic'

export const getTopic = (topicName: string): Promise<Topic | null> => {
  return serverFetch<Topic>(`/topics/${topicName}`).then(filterResponse)
}
